<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <span class="headline mb-0">倉庫別コンテナ受入枠検索 </span>
    </v-card-title>
    <v-card-actions>
      <v-btn v-permit.SHARP_WAREHOUSE_SETTING_SEARCH class="btn-search" @click="search()">{{ $t('app.buttons.search') }}</v-btn>
      <v-btn v-permit.SHARP_WAREHOUSE_SETTING_NEW to="/M0290/new">{{
          $t('app.buttons.new')
        }}</v-btn>
      <v-btn v-permit.SHARP_WAREHOUSE_SETTING_EDIT @click="edit()" :disabled="selected.length !== 1">{{ $t('app.buttons.edit') }}</v-btn>
      <table-upload v-permit.SHARP_WAREHOUSE_SETTING_UPLOAD title="アップロード" @input="upload" />
      <v-btn v-permit.SHARP_WAREHOUSE_SETTING_DOWNLOAD @click="$refs.downloadDialog.popup()">コンテナ枠実績差異</v-btn>
      <v-btn v-permit.SHARP_WAREHOUSE_SETTING_BATCH_UPDATE @click="editLimit()">コンテナ枠変更</v-btn>
      <a @click="$downloadTemplate('M0290', 'excel')" href="#">Excel template</a>
    </v-card-actions>
    <v-form>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs3>
            <remote-autocomplete label="納入場所" url="warehouses/reservable-kv" v-model="query.warehouseId"></remote-autocomplete>
          </v-flex>
          <v-flex xs3>
            <remote-autocomplete label="事業本部" url="divisions/kv?type=BU" v-model="query.buId"></remote-autocomplete>
          </v-flex>
          <v-flex xs3>
            <remote-autocomplete label="BU" url="divisions/kv?type=BUSINESS_UNIT" v-model="query.businessUnitId"></remote-autocomplete>
          </v-flex>
          <v-flex xs3>
            <remote-autocomplete label="品種グループ" url="product-groups/all-kv?" v-model="query.productGroupName"></remote-autocomplete>
            <!-- <v-text-field clearable label="機種名称" v-model="query.model" /> -->
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>

  <v-card class="mt-2">
    <v-toolbar flat>
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat icon color="deep-orange" @click="back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-btn flat icon color="deep-orange" @click="forward()">
        <v-icon>arrow_forward</v-icon>
      </v-btn>
    </v-toolbar>

    <fixed-column-wrap :data="results">
      <template slot-scope="{}">
        <v-data-table :headers="headers" :items="results" :loading="loading" :rows-per-page-items="[-1]" item-key="[0].id" select-all v-model="selected">
          <!-- <template slot="headerCell" slot-scope="props">
            <span>
              {{ props.header.text }}
            </span>
          </template> -->
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
            </td>
            <td>
              {{ getWarehouse(props.item[0]) }}
            </td>
            <td>
              {{
                props.item[0] && props.item[0].companyCode
                  ? props.item[0].companyCode
                  : getBu(props.item[0])
              }}
            </td>
            <td>
              {{ getBusinessUnit(props.item[0]) }}
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ item[0] && item[0].productGroupName }}
              </div>
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ getUpperLimit(headers[4], item) }}
              </div>
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ getUpperLimit(headers[5], item) }}
              </div>
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ getUpperLimit(headers[6], item) }}
              </div>
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ getUpperLimit(headers[7], item) }}
              </div>
            </td>
            <td>
              <div v-for="item in getProductGroup(props.item)" :key="item.id">
                {{ getUpperLimit(headers[8], item) }}
              </div>
            </td>
          </template>
        </v-data-table>
      </template>
    </fixed-column-wrap>
  </v-card>
  <edit-dialog @refresh="search" ref="editDialog" />
  <download-dialog :dif="true" ref="downloadDialog"></download-dialog>
</v-container>
</template>

<script>
import EditDialog from './EditDialog'
import DownloadDialog from './DownloadDialog'
export default {
  components: {
    EditDialog,
    DownloadDialog
  },
  data() {
    return {
      yearMonth: null,
      selected: [],
      results: [],
      displayResults: [],
      loading: false,
      pagination: {
        page: 1,
      },
      query: {},
      headers: [{
          text: '納入場所',
          value: '',
          sortable: false,
          class: 'fixed'
        },
        {
          text: '事業本部',
          value: '',
          sortable: false,
          class: 'fixed'
        },
        {
          text: 'BU',
          value: '',
          sortable: false,
          class: 'fixed'
        },
        {
          text: '品種グループ',
          value: '',
          sortable: false,
          class: 'fixed'
        },
      ],
      dialog: false,
      dateRange: [],
      totalDatas: [],
      date: null,
      year: null,
      month: null,
      currentSetting: {
        warehouseId: null,
        buId: null,
        businessUnitId: null,
        productGroupName: null,
      },
      bus: [],
      errors: {
        ILLEGAL_WAREHOUSE: '纳入场所不存在',
        ILLEGAL_BU: '事业本部不存在',
        ILLEGAL_BUSINESS_UNIT: 'BU不存在',
        ILLEGAL_PRODUCT_GROUP: '品种group不存在'
      }
    }
  },
  methods: {
    search() {
      this.yearMonth = null
      this.query.yearMonth = null
      this.pagination.page = 1
      this.$storeParams()
      this.load()
    },
    params() {
      return {
        params: {
          ...this.$pageable(),
          type: 'BU',
        },
      }
    },
    loadBUs() {
      this.$http.get('/divisions', this.params()).then((res) => {
        this.bus = res.data.content
      })
    },
    load() {
      this.totalDatas = []
      this.$http
        .get(`/warehouse-container-settings`, {
          params: {
            ...this.query,
            dateRange: this.dateRange.join(',')
          },
        })
        .then((res) => {
          this.results = res.data.sort((a, b) => {
            return this.$sortByProps(a, b, {
              warehouseCode: 'desc',
              buId: 'desc',
              productGroupName:'desc'
            })
          })

          var newData = this.initData1(res.data)
          newData.forEach((d, index) => {
            var total = {
              id: index,
              buCode: d[0].buCode,
              buId: d[0].buId,
              buName: d[0].buName,
              companyCode: d[0].companyCode,
              companyId: d[0].companyId,
              companyName: d[0].companyName,
              warehouseCode: d[0].warehouseCode,
              warehouseId: d[0].warehouseId,
              warehouseName: d[0].warehouseName,
              isTotal: true,
            }

            this.dateRange.forEach((date) => {
              var totalUpperLimit = d
                .filter((a) => a.date === date)
                .reduce((t, r) => t + r.upperLimit, 0)
              total = {
                ...total,
                [date]: totalUpperLimit
              }
            })

            this.totalDatas.push(total)
          })

          newData = [...newData, ...this.totalDatas]

          this.results = this.initData(res.data)
          this.totalDatas.forEach((td) => {
            this.results.push([td])
          })
          this.results = this.results.sort((a, b) => {
            return this.$sortByProps(a[0], b[0], {
              warehouseCode: 'desc',
              buId: 'desc',
              productGroupName:'desc'
            })
          })
        })
    },
    initDate() {
      this.query.dateRange = []
      for (var i = 0; i < 5; i++) {
        var date = this.addDate(this.date, i)
        this.headers.push({
          text: date,
          sortable: false
        })
        this.dateRange.push(date)
      }
    },
    addDate(date, days) {
      var d = new Date(date)
      d.setDate(d.getDate() + days)
      var m = d.getMonth()
      return new Date(d.getFullYear(), m, d.getDate()).format('yyyy-MM-dd')
    },
    initData(data) {
      var a = this.groupBy(data, function (item) {
        return [item.warehouseId, item.buId, item.businessUnitId]
      })
      return a
    },
    initData1(data) {
      var a = this.groupBy(data, function (item) {
        return [item.warehouseId, item.buId]
      })
      return a
    },
    groupBy(array, f) {
      let groups = {}
      array.forEach(function (o) {
        let group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function (group) {
        return groups[group]
      })
    },
    getWarehouse(item) {
      if (item.isTotal) {
        return ''
      }
      return item.warehouseCode + ':' + item.warehouseName
    },
    getBu(item) {
      if (item.isTotal) {
        return ''
      }
      return item.buCode + ':' + item.buName
    },
    getBusinessUnit(item) {
      if (item.isTotal) {
        return '合計'
      }
      return item.businessUnitName
    },
    getProductGroup(data) {
      if (data.length > 0 && data[0].isTotal) {
        return [data]
      }
      var a = this.groupBy(data, function (item) {
        return [item.productGroupName]
      })
      return a
    },
    getUpperLimit(date, dataSource) {
      if (dataSource.length > 0 && dataSource[0].isTotal) {
        return dataSource[0][date.text]
      }
      var setting = dataSource.find((d) => date.text === d.date)
      if (setting) {
        return setting.upperLimit
      }
      return 0
    },
    getUsed(date, dataSource) {
      var setting = dataSource.find((d) => date.text === d.date)
      if (setting) {
        return setting.used
      }
      return 0
    },
    edit() {
      this.$router.push({
        path: 'M0290/edit',
        query: {
          id: this.selected[0][0].id,
          warehouseId: this.selected[0][0].warehouseId,
          companyId: this.selected[0][0].companyId,
          buId: this.selected[0][0].buId,
          businessUnitId: this.selected[0][0].businessUnitId,
          year: this.year,
          month: this.month,
        },
      })
    },
    validUploadData(data) {
      console.log(data)
      if (
        data.filter((d) => !d.warehouseCode || !d.buCode || !d.productGroupName)
        .length > 0
      ) {
        this.$message(
          '',
          'アップロードが失敗になっています。SJL納入場所コードと事業本部コードと品種グループは必須項目です。必須項目を記入しているかをご確認ください。'
        )
        return false
      }
      console.log(this.bus)
      if (
        data.filter((d) => {
          var bu = this.bus.find((bu) => bu.code === d.buCode)
          console.log(bu)
          return bu && bu.careBu && !d.businessUnitCode
        }).length > 0
      ) {
        this.$message(
          '',
          'アップロードが失敗になっています。SJL納入場所コードと事業本部コードとＢＵコードと品種グループは必須項目です。必須項目を記入しているかをご確認ください。'
        )
        return false
      }
      return true
    },
    upload(data) {
      var totalSettings = []

      for (var i = 1; i < data.length; i++) {
        var setting = {
          warehouseCode: data[i][0],
          buCode: data[i][1],
          businessUnitCode: data[i][2],
          productGroupName: data[i][3],
        }
        for (var j = 4; j < data[i].length; j++) {
          totalSettings.push({
            ...setting,
            upperLimit: data[i][j] || 0,
            date: data[0][j],
          })
        }
      }

      if (!this.validUploadData(totalSettings)) {
        return
      }

      Promise.all(
          totalSettings.map((d) => {
            return this.$http.post(`warehouse-container-settings/excel/upload`, d)
          })
        )
        .then((res) => {
          console.log(res)
          var failed = res.map((r) => r.data).filter((r) => !r.success)
          console.log(failed)
          if (failed.length === 0) {
            this.$message('', 'SUCCESS')
          } else {
            var errors = []
            failed.forEach((f) => {
              if (errors.indexOf(f.localeMessage) === -1) {
                errors.push(f.localeMessage)
              }
            })
            var errMsg = errors.join(',')
            this.$message('', errMsg)
          }
          this.load()
        })
        .catch((err) => {
          console.log(err.response)
          this.$message('error', err.response.data.message)
        })
    },

    exportCsv() {
      this.$http
        .get(`/warehouse-container-settings`, {
          params: {
            ...this.query,
            yearMonth: this.yearMonth
          },
        })
        .then((res) => {
          console.log(res.data)

          var showResults = []

          var dateRange = []
          res.data
            .map((r) => r.date)
            .forEach((r) => {
              if (dateRange.indexOf(r) === -1) {
                dateRange.push(r)
              }
            })
          console.log(dateRange)

          dateRange = dateRange.sort((d1, d2) => d1.localeCompare(d2))
          console.log(dateRange)

          var groupedData = this.groupBy(res.data, function (item) {
            return [
              item.warehouseId,
              item.buId,
              item.businessUnitId,
              item.productGroupName,
            ]
          })

          groupedData.forEach((data) => {
            var sortedData = data.sort((a, b) => {
              return this.$sortByProps(a, b, {
                date: 'asc',
              })
            })
            var newObject = {
              warehouseCode: data[0].warehouseCode,
              warehouseName: data[0].warehouseName,
              buCode: data[0].buCode,
              buName: data[0].companyName || data[0].buName,
              businessUnitCode: data[0].businessUnitCode,
              businessUnitName: data[0].businessUnitName,
              productGroupName: data[0].productGroupName,
            }

            dateRange.forEach((d) => {
              var setting = sortedData.find((s) => s.date === d)
              newObject[d] = (setting && setting.upperLimit) || 0
            })

            // sortedData.forEach((s) => {
            //   newObject[s.date] = s.upperLimit || 0
            // })
            showResults.push(newObject)
            console.log(newObject)
          })

          let headers = [
            'warehouseCode',
            'warehouseName',
            'buCode',
            'buName',
            'businessUnitCode',
            'businessUnitName',
            'productGroupName',
          ].concat(dateRange)

          let showHeaders = [
            '納入場所Code',
            '納入場所',
            '事業本部Code',
            '事業本部',
            'BU Code',
            'BU',
            '品種グループ',
          ].concat(dateRange)

          this.$exportTable(
            showResults,
            headers,
            showHeaders,
            'warehouse-service'
          )
        })
    },
    back() {
      this.dateRange = []
      this.date = this.addDate(this.date, -5)
      this.headers.splice(4, 5)
      for (var i = 0; i < 5; i++) {
        var date = this.addDate(this.date, i)
        this.dateRange.push(date)
        this.headers.push({
          text: date,
          sortable: false
        })
      }
      this.search()
    },
    forward() {
      this.dateRange = []
      this.date = this.addDate(this.date, 5)
      this.headers.splice(4, 5)
      for (var i = 0; i < 5; i++) {
        var date = this.addDate(this.date, i)
        this.dateRange.push(date)
        this.headers.push({
          text: date,
          sortable: false
        })
      }
      this.search()
    },
    editLimit() {
      this.$refs.editDialog.popup()
    },
  },
  watch: {},
  mounted() {
    this.$loadParams()
    this.date = new Date()
    this.year = this.date.getFullYear()
    this.month = this.date.getMonth()
    this.initDate()
    this.load()
    this.loadBUs()
  },
  created() {},
}
</script>
